import './DocumentTemplate.scss';
import { IconArrowMedium } from '../icons/svgs';
import Utils from '../CourseApp/Helper/utils';
import DocumentPreview from '../preview/DocumentPreview';
import NextAction from '../actions/NextAction';

class DocumentTemplate {
    structures() {
        return {
            title: {
                type: 'text',
                label: 'Title',
                placeholder: 'Create a cool title',
            },
            attachment: {
                label: 'Add Document',
                type: 'attachment',   // file attachment max 1, allowed file type: PDF, EXCEL, WORD, PPT
                rules: {
                    allowedFileType: ['.pdf', '.docx', '.ppt', '.pptx', '.xlsx', '.zip', '.rar'],
                    maxFileSize: 25 * 1024 * 1024, // 25MB, if more than 25mb change upload method use TUS upload
                }
            },
            downloadable: {
                type: 'radio',
                labelOnChangeOption: 'Users can download uploaded document',
                trueLabel : 'Yes',
                falseLabel: 'No',
                relatedRequired: {
                    attachment: {
                        type: 'application/pdf'
                    }
                }, // only required if attachment type=pdf
            }
        }
    }
    type() {
        return 'DocumentTemplate';
    }
    name() {
        return 'Document';
    }
    iconType() {
        return 'document';
    }
    canRearrange() {
        return true;
    }
    canRenameLabel() {
        return true;
    }
    imageTemplate() {
        return (
            <div>
                <img src={require('../assets/img/template-image-document.jpg')} className='img-fluid' alt='document template' />
            </div>
        );
    }
    textHighlight() {
        return (
            <div>
                <span className='text-muted'>Also you can upload document such as;</span>
                <span className='font-weight-700 text-dark text-uppercase'> {this.structures().attachment.rules.allowedFileType.join(', ')}</span>
                <span className='text-muted'> work best for under {Utils.convertBytes(this.structures().attachment.rules.maxFileSize, 0)} file.</span>
            </div>
        );
    }
    getDuration() {
        return 60;
    }
    render(data, index, inEditor) {
        return (
            <DocumentPreview data={data} index={index} inEditor={inEditor} structures={this.structures()} />
        )
    }

    actions(data, index) {
        return (
            <NextAction label='Next' icon={<IconArrowMedium />} />
        );
    }
}


export default DocumentTemplate;
